import { render, staticRenderFns } from "./cowIndividualVaccination.vue?vue&type=template&id=26c7446a&scoped=true&"
import script from "./cowIndividualVaccination.vue?vue&type=script&lang=js&"
export * from "./cowIndividualVaccination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c7446a",
  null
  
)

export default component.exports